module.exports = __webpack_public_path__ + "img/icon3.700360b9.svg";